"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecisionHeuristicConfigSchema = exports.WaterfallByExcessMarginSchema = exports.WaterfallByExcessMarginConfigSchema = exports.AssignByTotalAssignableExposureConfigSchema = exports.LoanProductConfigSchema = exports.CreditFacilityAllocationSchema = exports.HardRequirementTypeSchema = exports.HardRequirementTypeIterable = exports.DecisionHeuristicMethodTypeSchema = exports.DecisionHeuristicMethodTypeIterable = void 0;
const zod_1 = require("zod");
// ============================================================================
// DECISION HEURISTIC METHOD TYPE SCHEMA
// ============================================================================
exports.DecisionHeuristicMethodTypeIterable = [
    'assignByTotalAssignableExposure',
    'waterfallByExcessMargin',
];
exports.DecisionHeuristicMethodTypeSchema = zod_1.z.enum(exports.DecisionHeuristicMethodTypeIterable);
// ============================================================================
// HARD REQUIREMENT TYPE SCHEMA
// ============================================================================
exports.HardRequirementTypeIterable = [
    'minimum',
    'maximum',
    'none',
];
exports.HardRequirementTypeSchema = zod_1.z.enum(exports.HardRequirementTypeIterable);
// ============================================================================
// CREDIT FACILITY ALLOCATION SCHEMA
// ============================================================================
exports.CreditFacilityAllocationSchema = zod_1.z.object({
    creditFacilityId: zod_1.z.string(),
    allocation: zod_1.z.number(),
    hardRequirement: exports.HardRequirementTypeSchema,
});
// ============================================================================
// LOAN PRODUCT CONFIG SCHEMA
// ============================================================================
exports.LoanProductConfigSchema = zod_1.z.object({
    loanProductId: zod_1.z.string(),
    creditFacilityAllocations: zod_1.z.array(exports.CreditFacilityAllocationSchema),
    balanceSheetAllocation: zod_1.z.number(),
});
// ============================================================================
// ASSIGN BY TOTAL ASSIGNABLE EXPOSURE CONFIG SCHEMA
// ============================================================================
exports.AssignByTotalAssignableExposureConfigSchema = zod_1.z.object({
    heuristicType: zod_1.z.literal('assignByTotalAssignableExposure'),
    config: zod_1.z.object({
        loanProductConfigs: zod_1.z.array(exports.LoanProductConfigSchema),
    }),
});
// ============================================================================
// WATERFALL BY EXCESS MARGIN CONFIG SCHEMA
// ============================================================================
const WaterfallByExcessMarginBalanceSheetStruct = zod_1.z.object({
    type: zod_1.z.literal('balanceSheet'),
    limitType: zod_1.z.enum(['min', 'max']),
    percentageRate: zod_1.z.number().optional(),
    value: zod_1.z.number().optional(),
});
const WaterfallByExcessMarginCreditFacilityStruct = zod_1.z.object({
    type: zod_1.z.literal('creditFacility'),
    creditFacilityId: zod_1.z.string(),
    limitType: zod_1.z.enum(['min', 'max']),
    percentageRate: zod_1.z.number().optional(),
    value: zod_1.z.number().optional(),
});
exports.WaterfallByExcessMarginConfigSchema = zod_1.z.discriminatedUnion('type', [
    WaterfallByExcessMarginBalanceSheetStruct,
    WaterfallByExcessMarginCreditFacilityStruct,
]);
// ============================================================================
// WATERFALL BY EXCESS MARGIN SCHEMA
// ============================================================================
exports.WaterfallByExcessMarginSchema = zod_1.z.object({
    heuristicType: zod_1.z.literal('waterfallByExcessMargin'),
    config: zod_1.z.object({
        waterfall: zod_1.z.array(exports.WaterfallByExcessMarginConfigSchema),
    }),
});
// ============================================================================
// DECISION HEURISTIC CONFIG SCHEMA
// ============================================================================
exports.DecisionHeuristicConfigSchema = zod_1.z.discriminatedUnion('heuristicType', [exports.AssignByTotalAssignableExposureConfigSchema, exports.WaterfallByExcessMarginSchema]);
//# sourceMappingURL=Assignment.js.map